import {useCallback, useEffect, useState} from "react";
import {useToast} from "@shopify/app-bridge-react";
import {useHistory} from "react-router-dom";
import Api from "../../../helpers/api";
import {Banner, Modal, LegacyStack, TextField} from "@shopify/polaris";
import {getFormError} from "../../../helpers/utils";

export const MergeModal = ({ show, customer, onClose }) => {
    const [accountNumber, setAccountNumber] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const updateAccountNumber = useCallback(value => setAccountNumber(value));
    const history = useHistory();

    useEffect(() => {
        setAccountNumber('')
        setErrors({});
        setLoading(false);
    }, [show]);

    const onMerge = useCallback(() => {
        setLoading(true);
        setErrors({});

        Api.mergeAccount(customer.id, accountNumber)
            .then(response => {
                toast.show('Account was merged successfully');
                history.push(`/customers/${response.data.customer_id}`);
            })
            .catch(error => {
                if (error.response.status == 422) {
                    setErrors(error.response.data.errors);
                } else {
                    toast.show(getErrorMessage(error), {
                        isError: true,
                    });
                }

                setLoading(false);
            });
    }, [customer.id, accountNumber]);

    return (
        <Modal open={show}
               title="Merge Account"
               onClose={onClose}
               secondaryActions={[
                   { content: 'Cancel', onAction: onClose }
               ]}
               primaryAction={{
                   content: 'Merge',
                   loading,
                   onAction: onMerge,
               }}>
            <Modal.Section>
                <LegacyStack vertical>
                    <LegacyStack.Item>
                        <TextField label="Account Number"
                                   type="text"
                                   autoComplete={'on'}
                                   value={accountNumber}
                                   onChange={updateAccountNumber}
                                   error={getFormError(errors, 'with_account')} />
                    </LegacyStack.Item>
                    <LegacyStack.Item>
                        <Banner tone="info">After merging the customer accounts, the associated locations will be moved to the other account, and the this customer account will be hidden.</Banner>
                    </LegacyStack.Item>
                </LegacyStack>
            </Modal.Section>
        </Modal>
    );
}
